import { dispatchPromise, fetchResources } from './action-helpers';

import { getCurrentUserId } from '../services/store-service';
import { createTempId } from '../utils/helpers';

const DEFAULT_TASK_PROPS = {
    archived: false,
    assignees: [],
    labels: [],
    fields: [],
    documents: [],
    comments: 0,
    completed: false,
    completed_subtasks: 0,
    created_by: null,
    id: null,
    name: '',
    order: Number.POSITIVE_INFINITY,
    milestone: undefined,
    project: undefined,
    task: undefined,
    task_group: undefined,
    total_subtasks: 0
};

export const createTask = taskProps => {
    return dispatchPromise({
        type: 'TASK_CREATE_REQUESTED',
        payload: {
            task: Object.assign({}, DEFAULT_TASK_PROPS, taskProps, {
                id: createTempId(),
                created_by: getCurrentUserId()
            })
        }
    });
}

export const fetchTasks = (fetchProps, all) => fetchResources('TASKS_FETCH_REQUESTED', fetchProps, all);

export const fetchTask = taskId => {
    return dispatchPromise({
        type: 'TASK_FETCH_REQUESTED',
        payload: { taskId }
    });
}

export const updateTask = (taskId, taskProps, preventSave) => {
    return dispatchPromise({
        type: 'TASK_UPDATE_REQUESTED',
        preventSave,
        payload: {
            taskId,
            taskProps
        }
    });
}

export const moveTask = (taskId, moveProps, preventSave) => {
    return dispatchPromise({
        type: 'TASK_MOVE_REQUESTED',
        preventSave,
        payload: {
            taskId,
            moveProps
        }
    });
}

export const removeTask = taskId => {
    return dispatchPromise({
        type: 'TASK_REMOVE_REQUESTED',
        payload: { taskId }
    });
}

export const removeArchivedTasks = projectId => {
    return dispatchPromise({
        type: 'ARCHIVED_TASKS_REMOVE_REQUESTED',
        payload: { projectId }
    });
}

export const assignTask = (taskId, assignees) => {
    return dispatchPromise({
        type: 'TASK_ASSIGN_REQUESTED',
        payload: {
            taskId,
            assignees
        }
    });
}

export const unassignTask = (taskId, assignees) => {
    return dispatchPromise({
        type: 'TASK_UNASSIGN_REQUESTED',
        payload: {
            taskId,
            assignees
        }
    });
}

export const setTaskVisibility = (taskId, visible, roles) => {
    return dispatchPromise({
        type: 'TASK_VISIBILITY_SET_REQUESTED',
        payload: {
            taskId,
            visible,
            roles
        }
    });
}

export const addTaskLabel = (taskId, labelId) => {
    return addTaskLabels(taskId, [labelId]);
}

export const addTaskLabels = (taskId, labels) => {
    return dispatchPromise({
        type: 'TASK_LABELS_ADD_REQUESTED',
        payload: {
            taskId,
            labels
        }
    });
}

export const removeTaskLabel = (taskId, labelId) => {
    return dispatchPromise({
        type: 'TASK_LABEL_REMOVE_REQUESTED',
        payload: {
            taskId,
            labelId
        }
    });
}

export const addTaskDoc = (taskId, docId) => {
    return dispatchPromise({
        type: 'TASK_DOC_ADD_REQUESTED',
        payload: {
            taskId,
            docId
        }
    });
}

export const removeTaskDoc = (taskId, docId) => {
    return dispatchPromise({
        type: 'TASK_DOC_REMOVE_REQUESTED',
        payload: {
            taskId,
            docId
        }
    });
}

export const reorderTasks = tasks => {
    return dispatchPromise({
        type: 'TASKS_REORDER_REQUESTED',
        payload: { tasks }
    });
}

export const archiveTasks = taskIds => {
    return dispatchPromise({
        type: 'TASKS_ARCHIVE_REQUESTED',
        payload: { taskIds }
    });
}

export const completeTasks = taskIds => {
    return dispatchPromise({
        type: 'TASKS_COMPLETE_REQUESTED',
        payload: { taskIds }
    });
}
